// packages block
import moment from "moment";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Grid, Avatar, Divider, Typography } from "@material-ui/core";
// common block
import { preaddStyles } from "./styles";
import { TextFieldComponent } from "../form/textFeild";
import { FormAutoSelect } from "../form/autoSearchSelect";
import { FormInput, FormSelect, InputWithLabel } from "../form";
// constants, theme, utils and api block
import { BLUE_EIGHT } from "../../theme";
import { MONTH_LIST } from "../../util/constants";

export const AddInvoiceForm = ({
  studentId,
  type,
  term,
  amount,
  schoolId,
  studentRegNo,
  file,
  firstName,
  lastName,
  grade,
  invoiceId,
  balanceVal,
  feeMonth,
  dueDate,
  otherFee,
  handleChange,
  isView,
  errors,
  studentIds,
  studentInfo,
  selectedForm,
  balanceList,

}) => {
  let newAmount = amount;
  let newOtherFee = otherFee;
  let total = Number(newOtherFee) + Number(newAmount);

  if (total === "") {
    total = balanceVal;
  }

  const [selForm, setSelForm] = useState('')
  const { role } = useSelector((state) => state.user);

  useEffect(() => {
    setSelForm(selectedForm)
  }, [selectedForm])

  const classes = preaddStyles();
  const AmountFormat = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };

  return (
    <div className={classes.addSchoolForm}>
      <Grid container spacing={2} className="invoice-form-header">
        <Grid item xs={6} className="column-1">
          <div className="inner-wrapper">
            <div className="img-box" >
              <Avatar>
                {/* {file !== null ? (
                  <img
                    style={{ height: "100%", width: "100%", objectFit: "cover" }}
                    src={file === "" ? '' : `${file}`}
                  />
                ) : (`${firstName[0]?.toUpperCase()}`
                )} */}
                { /* "{student.firstName[0].toUpperCase()}*/}
              </Avatar>

              <div className="textual-detail">
                <Typography variant="h6" style={{ color: BLUE_EIGHT }}>{firstName} {lastName} </Typography>
                <p className="student-title"> Student ID: {studentRegNo} </p>
                <p className="student-grade" > Grade: {grade} </p>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={6} className="column-2">
          <div className="date-text">
            <Typography variant="h6" style={{ color: BLUE_EIGHT }}> {dueDate ? moment(dueDate).format("DD-MM-YYYY") : ""} </Typography>
            <p> Due Date </p>
          </div>
          <div className="fees-text">
            <Typography variant="h6" style={{ color: BLUE_EIGHT }}>
              AED {AmountFormat(total)}
            </Typography>
            <p> Total Payable Fee </p>
          </div>
        </Grid>
      </Grid>
      <br />
      <Divider />
      <br />

      {
        isView ? (
          <p style={
            { fontSize: "14px", color: "#276E7D", fontWeight: "1000" }} >
            View Invoice Details
          </p>
        ) : (
          <p style={
            { fontSize: "14px", color: "#276E7D", fontWeight: "1000" }} >
            Enter Fee Details
          </p>
        )
      }

      <Grid container className={classes.gridRoot} spacing={2}>

        {selForm === "balance" && role === "manager" && <>
          <Grid item sm={6} xs={12} >
            <InputWithLabel
              type="date"
              required={true}
              errorMessage={errors.indexOf("dueDate") > -1 === true && 'dueDate is required'}
              error={errors.indexOf("dueDate") > -1}
              value={dueDate}
              onChange={handleChange}
              label={"Due Date"}
              name="dueDate"
              extraClass="nomr"
              disabled={isView ? true : false}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <TextFieldComponent
              errorMessage={errors.indexOf("balanceVal") > -1 === true && "Amount always greater than Zero !"}
              error={errors.indexOf("balanceVal") > -1}
              value={balanceVal}
              required={true}
              onChange={handleChange}
              label={"Balance"}
              name="balanceVal"
              disabled={isView ? true : false}
              type="number"
            />
          </Grid>
        </>}
      </Grid>
    </div >
  );
};